/**
 * Dot animado para Recharts — sinaliza ao usuário que o ponto é clicável.
 * Renderiza um círculo sólido + um halo que cresce e desaparece em loop.
 *
 * Recharts passa {cx, cy, payload, index, ...} automaticamente pro componente
 * referenciado em <Line dot={...} /> ou <Line activeDot={...} />.
 */
export function PulsingDot({
  cx,
  cy,
  color,
  interactive,
  onClick,
  payload,
}: {
  cx?: number;
  cy?: number;
  color: string;
  interactive: boolean;
  onClick?: (payload: unknown) => void;
  payload?: unknown;
}) {
  if (typeof cx !== "number" || typeof cy !== "number") return null;

  const handleClick = interactive && onClick && payload ? () => onClick(payload) : undefined;

  return (
    <g style={{ cursor: interactive ? "pointer" : "default" }}>
      {interactive && (
        <circle
          cx={cx}
          cy={cy}
          r={4}
          fill={color}
          className="animate-pulse-ring"
          style={{ transformBox: "fill-box", transformOrigin: "center" }}
          pointerEvents="none"
        />
      )}
      <circle
        cx={cx}
        cy={cy}
        r={3.5}
        fill={color}
        stroke="hsl(var(--bg-card))"
        strokeWidth={1.5}
        onClick={handleClick}
      />
    </g>
  );
}
